// Using CJS export syntax so that this is usable in gatsby-node.js
// Can be removed once Node LTS supports ES modules

exports.JSON_LD_ORGANIZATION = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': '{{siteurl}}/#organization',
  name: 'Splashtop',
  Legalname: 'Splashtop Inc.',
  foundingDate: '2006',
  url: '{{siteurl}}',
  logo: '{{siteurl}}/splashtop-logo-large.png',
  description: 'Splashtop is a leading provider of remote desktop access, remote support, IoT, screen mirroring, and screen sharing solutions for IT, MSPs, business professionals and education.',
  sameAs: [
    'https://www.facebook.com/Splashtop/',
    'https://twitter.com/splashtop',
    'https://www.linkedin.com/company/splashtop',
    'https://www.youtube.com/user/SplashtopInc'
  ],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Cupertino',
    addressRegion: 'CA',
    addressCountry: 'US',
    postalCode: '95014',
    streetAddress: '10050 North Wolfe Road, Suite SW2-S260'
  }
};

/* eslint-disable quote-props */
exports.SYMBOL_CURRENCIES = {
  'C$': 'CAD',
  'AUD': 'AUD',
  '£': 'GBP',
  '$': 'USD',
  'MXN': 'MXN',
  'CHF': 'CHF',
  '€': 'EUR',
  '¥': 'CNY',
  'BRL': 'BRL',
  'NOK': 'NOK',
  'SEK': 'SEK',
  'DKK': 'DKK',
  'TWD': 'TWD',
  'JPY': 'JPY',
  '₹': 'INR'
};
/* eslint-enable quote-props */

exports.DEFAULT_CURRENCY = 'USD';

exports.REGION_COUNTRIES = {
  aud: ['au', 'cx', 'cc', 'nr', 'tv', 'ki', 'nf', 'hm'],
  brl: ['br'],
  canada: ['ca'],
  emea: ['nz', 'ax', 'al', 'am', 'az', 'by', 'ba', 'ge', 'is', 'kz', 'li', 'mk', 'md', 'ru', 'rs', 'sj', 'tr', 'ua', 'va', 'iq', 'sa', 'ye', 'sy', 'ae', 'il', 'jo', 'ps', 'lb', 'om', 'kw', 'qa', 'bh', 'ir', 'ng', 'et', 'eg', 'cd', 'za', 'tz', 'ke', 'dz', 'ug', 'sd', 'ma', 'gh', 'mz', 'ci', 'mg', 'ao', 'cm', 'ne', 'bf', 'ml', 'mw', 'zm', 'sn', 'zw', 'td', 'gn', 'tn', 'rw', 'ss', 'bj', 'so', 'bi', 'tg', 'ly', 'sl', 'cf', 'er', 'cd', 'lr', 'mr', 'ga', 'na', 'bw', 'ls', 'gq', 'gm', 'gw', 'mu', 'sz', 'dj', 're', 'km', 'eh', 'cv', 'yt', 'st', 'sc'],
  eu: ['ad', 'at', 'be', 'cy', 'ee', 'fi', 'de', 'gr', 'ie', 'it', 'lv', 'lt', 'lu', 'mc', 'me', 'mt', 'nl', 'pt', 'sk', 'si', 'sm', 'es', 'bg', 'hr', 'cz', 'hu', 'pl', 'ro', 'xk'],
  fr: ['fr'],
  gbp: ['gb', 'im', 'je', 'gg', 'fk', 'gi', 'sh'],
  jpy: ['jp'],
  yuan: ['cn'],
  mxn: ['mx'],
  chf: ['ch', 'li'],
  sek: ['se'],
  nok: ['no'],
  dkk: ['dk', 'gl', 'fo'],
  twd: ['tw'],
  india: ['in']
};

exports.REGION_ZONES = {
  aud: 'AUD',
  brl: 'BRL',
  canada: 'Canada',
  default: 'Zone1',
  mxn: 'MXN',
  emea: 'Zone2',
  eu: 'AllEurosZ3',
  chf: 'CHF',
  fr: 'Zone4',
  gbp: 'GBP',
  jpy: 'JPY',
  twd: 'TWD',
  yuan: 'Zone5',
  sek: 'SEK',
  nok: 'NOK',
  dkk: 'DKK',
  india: 'India'
};

exports.DEFAULT_LANGUAGE = 'en';

exports.LANGUAGES = {
  en: {
    path: null,
    hreflang: 'en',
    name: 'English'
  },
  de: {
    path: 'de',
    hreflang: 'de',
    name: 'Deutsch'
  },
  es: {
    path: 'es',
    hreflang: 'es',
    name: 'Español'
  },
  fr: {
    path: 'fr',
    hreflang: 'fr',
    name: 'Français'
  },
  it: {
    path: 'it',
    hreflang: 'it',
    name: 'Italiano'
  },
  nl: {
    path: 'nl',
    hreflang: 'nl',
    name: 'Nederlands'
  },
  pt: {
    path: 'pt',
    hreflang: 'pt',
    name: 'Português'
  },
  'zh-Hans': {
    path: 'cn',
    hreflang: 'zh-Hans',
    name: '简体中文'
  },
  'zh-Hant': {
    path: 'tw',
    hreflang: 'zh-Hant',
    name: '繁體中文'
  },
  jp: {
    name: '日本語'
  },
  kr: {
    name: '한국어'
  },
  th: {
    name: 'ภาษาไทย'
  },
  id: {
    name: 'Bahasa'
  }
};

exports.DEFAULT_POSTS_PER_PAGE = 12;

exports.GEOLOCATE_API_ENDPOINT = 'https://st-lookup.api.splashtop.com/api/v1/lookup_geo';

exports.SITE_URL = process.env.GATSBY_SITE_URL;

exports.CN_SITE_URL = process.env.GATSBY_CN_SITE_URL;

exports.JP_SITE_URL = process.env.GATSBY_JP_SITE_URL;

exports.KR_SITE_URL = 'https://kr.splashtop.com';

exports.TH_SITE_URL = 'https://th.splashtop.com';

exports.ID_SITE_URL = 'https://id.splashtop.com';

exports.HUBSPOT_PORTAL_ID = 20265280;

exports.INTERNAL_HOSTNAMES = [
  'q2-dev.splashtop.com',
  'web-dev.splashtop.com',
  'web-test.splashtop.com',
  'splashtop.com',
  'www.splashtop.com',
  'splashtop.gatsbyjs.io',
  'localhost'
];

exports.KNOWN_DOMAINS_RE = /splashtop\.(com|eu|cn|co\.jp)$/i;

exports.TARGET_BLANK_DOMAINS_RE = /(support-|\.ssw)/i;

exports.EU_REPLACE_DOMAINS_RE = /(my|sos)\.splashtop\.com$/i;

exports.HEADER_BLOCK_TYPENAMES = [
  'ContentfulAnimatedHero',
  'ContentfulHeader',
  'ContentfulHero',
  'ContentfulMiniHeader',
  'ContentfulPhotoHeader',
  'ContentfulText'
];
